import axios from "../../axiosDod.js";

const fetchReportArchive = async ({ commit }, { page = 1, limit = 20 } = {}) => {
  const response = await axios.get(`reportArchive`, { params: { page, limit } });
  commit("SET_REPORT_ARCHIVE", response.data);
  return response.data;
};

// Generates AND stores the report; the caller downloads the returned row's file afterwards.
const generateArchivedReport = async (_ctx, payload) => {
  const response = await axios.post(`reportArchive/generate`, payload);
  return response.data;
};

const downloadArchivedReport = async (_ctx, { id, filename }) => {
  const response = await axios.get(`reportArchive/${id}/file`, {
    responseType: "blob",
  });
  const fileURL = URL.createObjectURL(response.data);
  const fileLink = document.createElement("a");
  fileLink.href = fileURL;
  fileLink.setAttribute("download", filename || "raport");
  document.body.appendChild(fileLink);
  fileLink.click();
  document.body.removeChild(fileLink);
  URL.revokeObjectURL(fileURL);
};

export default {
  fetchReportArchive,
  generateArchivedReport,
  downloadArchivedReport,
};
